import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService } from '../data.service';
import { SettingMonitorOutpatientQueue } from 'src/app/shared/models/antrian/setting-monitor-outpatient-queue.model';
import { SettingMonitorOutpatientQueueApiService } from '../../api/antrian/setting-monitor-outpatient-queue.api.service';

@Injectable({
  providedIn: 'root',
})
export class SettingMonitorOutpatientQueueDataService
  implements DataService<SettingMonitorOutpatientQueue>
{
  constructor(
    private settingMonitorOutpatientQueueApiService: SettingMonitorOutpatientQueueApiService
  ) {}

  public getAll(): Observable<SettingMonitorOutpatientQueue[]> {
    return this.settingMonitorOutpatientQueueApiService.getAll();
  }

  public fetchBySettingNumber(settingNumber: number): Observable<SettingMonitorOutpatientQueue[]> {
    return this.settingMonitorOutpatientQueueApiService.fetchBySettingNumber(settingNumber);
  }

  public createOrUpdate(data: any): Observable<any> {
    return this.settingMonitorOutpatientQueueApiService.createOrUpdate(data);
  }
}
